"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { addToast } from "@xefi/x-react/toast";
import { useTranslation } from "react-i18next";
import { useImportStatus } from "@/hooks/useImportStatus";
import { useImportTrackerStore } from "@/store/useImportTrackerStore";
const INVALIDATED_ON_SUCCESS = [["payments", "telecollections"], ["payments", "missing-card-payments"], ["payments", "national-transfers"], ["payments", "imports"], ["payments", "kpi"]] as const;
export default function ImportTracker() {
  const $ = _c(4);
  const trackedIds = useImportTrackerStore(_temp);
  let t0;
  if ($[0] !== trackedIds) {
    t0 = trackedIds.map(_temp2);
    $[0] = trackedIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(id) {
  return <TrackedImportWatcher key={id} importId={id} />;
}
function _temp(state) {
  return state.trackedIds;
}
type WatcherProps = {
  importId: string;
};
function TrackedImportWatcher(t0) {
  const $ = _c(15);
  const {
    importId
  } = t0;
  const {
    t
  } = useTranslation();
  const queryClient = useQueryClient();
  const untrack = useImportTrackerStore(_temp3);
  const {
    data
  } = useImportStatus(importId);
  const status = data?.status;
  const hasNotified = useRef(false);
  let t1;
  if ($[0] !== data?.error_details || $[1] !== data?.original_filename || $[2] !== importId || $[3] !== queryClient || $[4] !== status || $[5] !== t || $[6] !== untrack) {
    t1 = () => {
      if (hasNotified.current) {
        return;
      }
      if (status === "success") {
        hasNotified.current = true;
        addToast({
          title: t("paymentsReceived.import.success"),
          description: data?.original_filename ?? undefined,
          color: "success"
        });
        INVALIDATED_ON_SUCCESS.forEach(queryKey => queryClient.invalidateQueries({
          queryKey
        }));
        untrack(importId);
      }
      if (status === "failed") {
        hasNotified.current = true;
        addToast({
          title: t("paymentsReceived.import.failed"),
          description: data?.error_details?.join("\n"),
          color: "danger"
        });
        queryClient.invalidateQueries({
          queryKey: ["payments", "imports"]
        });
        untrack(importId);
      }
    };
    $[0] = data?.error_details;
    $[1] = data?.original_filename;
    $[2] = importId;
    $[3] = queryClient;
    $[4] = status;
    $[5] = t;
    $[6] = untrack;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== data || $[9] !== importId || $[10] !== queryClient || $[11] !== status || $[12] !== t || $[13] !== untrack) {
    t2 = [status, importId, data, queryClient, t, untrack];
    $[8] = data;
    $[9] = importId;
    $[10] = queryClient;
    $[11] = status;
    $[12] = t;
    $[13] = untrack;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  useEffect(t1, t2);
  return null;
}
function _temp3(state) {
  return state.untrack;
}